import React from 'react';
import { ShoppingCart } from 'lucide-react';

export default function ProductCard({ product, onAddToCartClick }) {
  if (!product || typeof product !== 'object') return null;

  return (
    <div
      className="bg-white border border-gray-200 rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden cursor-pointer"
      onClick={onAddToCartClick}
    >
      <img
        src={product.image || 'https://placehold.co/400x400?text=No+Image'}
        alt={product.name || 'Unnamed Product'}
        className="w-full h-64 object-cover"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = 'https://placehold.co/400x400/e2e8f0/a0aec0?text=Image+Error';
        }}
      />
      <div className="p-4 text-center">
        <h2 className="text-lg font-semibold text-gray-800">{product.name}</h2>
        <p className="text-teal-600 font-bold text-xl mt-2">
          ₹{product.price.toFixed(2)}
        </p>
        <div className="mt-2 text-sm text-gray-400">Click to add to cart</div>
        {/* 👇 Remove the separate button to avoid double clicks */}
        {/* <button ...>Add to Cart</button> */}
      </div>
    </div>
  );
}
